import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CalendarHeaderProps {
  data: {
    viewMode: "today" | "weekly" | "monthly";
    title: string;
    subTitle: string;
  };

  handlers: {
    onPrevious: () => void;
    onNext: () => void;
    onToday: () => void;
  };
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ data, handlers }) => {
  const { title, subTitle } = data;

  const { onPrevious, onNext, onToday } = handlers;
  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Order Services</h1>

        <p className="text-gray-500 mt-1">
          Manage bookings and Services.
        </p>
      </div>

      <div className="flex items-center gap-3 flex-shrink-0">
        <div className="flex items-center gap-2">
          <button
            onClick={onPrevious}
            className="p-2 border rounded-lg hover:bg-gray-50"
          >
            <ChevronLeft size={18} />
          </button>

          <h2 className="text-lg font-semibold whitespace-nowrap px-4 text-center">
            {title}
          </h2>

          <button
            onClick={onNext}
            className="p-2 border rounded-lg hover:bg-gray-50"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
